module.exports = __webpack_public_path__ + "img/email.d5de1808.png";